
// export const getAdImageUrl = (API_ROOT) => {
//   const count = parseInt(
//     localStorage.getItem("adVisitCount") || "0",
//     10
//   );

//   let newSession;

//   if (count <= 3) {
//     newSession = true;
//   } else {
//     newSession = false;
//   }
  
//   return `${API_ROOT}/api/advertisement/get_active?newSession=${newSession}`;
// };
 

export const getAdImageUrl = (API_ROOT) => {
  const today = new Date().toISOString().split("T")[0];

  const lastDate = localStorage.getItem("adVisitDate");

  let sessionCount = parseInt(
    localStorage.getItem("adSessionCount") || "1",
    10
  );

  // New day
  if (lastDate !== today) {
    sessionCount = 0;
    localStorage.setItem("adVisitDate", today);
    localStorage.setItem("adSessionCount", "1");
  }

  // Check whether this session already sent true
  const alreadySent = sessionStorage.getItem("adNewSessionSent");

  let newSession = false;

  if (!alreadySent) {
    sessionCount += 1;

    localStorage.setItem(
      "adSessionCount",
      sessionCount.toString()
    );

    sessionStorage.setItem("adNewSessionSent", "true");

    // Only first 3 sessions get true
    if (sessionCount <= 3) {
      newSession = true;
    }
  }

  return `${API_ROOT}/api/advertisement/get_active?newSession=${newSession}`;
};